import type { CategoryCatalogSortKey } from '../types/product';

export const CATEGORY_CATALOG_SORT_KEYS = [
  'default',
  'price_asc',
  'price_desc',
  'newest',
  'name_asc',
] as const satisfies readonly CategoryCatalogSortKey[];

export const CATEGORY_CATALOG_SEARCH_MAX_LENGTH = 80;

export function parseCategoryCatalogSortKey(value: string | null): CategoryCatalogSortKey {
  return CATEGORY_CATALOG_SORT_KEYS.includes(value as CategoryCatalogSortKey)
    ? (value as CategoryCatalogSortKey)
    : 'default';
}

export function normalizeCategoryCatalogSearch(value: string | null | undefined): string {
  return (value ?? '').trim().slice(0, CATEGORY_CATALOG_SEARCH_MAX_LENGTH);
}

export function buildCategoryCatalogSearchParams(input: {
  readonly search?: string | null;
  readonly sort?: CategoryCatalogSortKey | null;
}): URLSearchParams {
  const params = new URLSearchParams();
  const search = normalizeCategoryCatalogSearch(input.search);
  const sort = parseCategoryCatalogSortKey(input.sort ?? null);

  if (search !== '') {
    params.set('q', search);
  }
  if (sort !== 'default') {
    params.set('sort', sort);
  }

  return params;
}
